<div class="content-wrapper">
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
      <span class="text-muted fw-light">Payments /</span> Payment Links
    </h4>

    <mat-card style="background-color: #fff;">
      <mat-card-header class="mt-3 mb-3">
        <span class="material-symbols-outlined" style="margin-right: 10px;">
          payments</span> Payment Links
      </mat-card-header>

      <mat-card-actions>
        <button class="createButton" mat-raised-button routerLink="/All/createpayment"><span
            class="material-symbols-outlined" style="margin-right: 5px;">
            add</span>Create Payment Link
        </button>
      </mat-card-actions>

      <!-- (Removed duplicate file-preview/process-upload block — Bulk Upload section handles file selection and upload) -->

      <!-- ==================== BULK UPLOAD HEADER (SINGLE LINE) ==================== -->
      <mat-card-actions class="mt-4 mb-2">
        <div class="bulk-card upload-container">
          <div class="left-side">
            <div class="bulk-title-area">
              <h1 id="page-title" class="bulk-title">Bulk Upload Transactions</h1>
            </div>

            <div class="file-info" style="display:flex;align-items:center;gap:12px;margin-left:8px;">
              <span class="file-name">{{ selectedFile?.name ? (selectedFile.name + ' (' + formatFileSize(selectedFile?.size) + ')') : 'No file chosen' }}</span>
              <button class="upload-btn" (click)="uploadCsv()" [disabled]="!selectedFile || isUploading">{{ isUploading ? 'Uploading...' : 'Upload File' }}</button>
              <span class="accepted">Accepted: .csv</span>
              <!-- Remove attachment button, visible only when a file is selected -->
              <button *ngIf="selectedFile" class="btn btn-outline-secondary" style="margin-left:6px;" (click)="removeFile()" title="Remove attachment">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M3 6h18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 11v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="right-side bulk-actions">
            <button id="download-btn" class="btn blue" (click)="downloadTemplate()">
              <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 3v10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 9l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 21H3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Download Template</span>
            </button>
            <button id="choose-btn" class="btn blue" (click)="fileInput.click()">
              <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 21V9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 13l4-4 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Choose File</span>
            </button>
          </div>
        </div>
      </mat-card-actions>

      <!-- UPLOAD RESULT TABLE -->
      <div *ngIf="uploadResults?.length > 0" class="mt-3" style="padding-left: 20px;">
        <h5>Upload Summary</h5>
        <p>
          <strong>Total:</strong> {{uploadSummary.total}} |
          <strong>Success:</strong> <span style="color: green">{{uploadSummary.success}}</span> |
          <strong>Failed:</strong> <span style="color: red">{{uploadSummary.failed}}</span>
        </p>

        <table mat-table [dataSource]="uploadResults" class="mat-elevation-z8">

          <ng-container matColumnDef="CustTransactionId">
            <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
            <td mat-cell *matCellDef="let row">
              {{ row.data?.requestGUID || row.data?.custTransactionId || 'N/A' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span [style.color]="row.status === 'error' ? 'red' : 'green'">
                {{ row.status }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ResponseCode">
            <th mat-header-cell *matHeaderCellDef>Code</th>
            <td mat-cell *matCellDef="let row"> {{ row.code }} </td>
          </ng-container>

          <ng-container matColumnDef="Message">
            <th mat-header-cell *matHeaderCellDef>Message</th>
            <td mat-cell *matCellDef="let row">
              {{ row.data?.responseDescription || row.data?.responseMessage || 'N/A' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="uploadDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: uploadDisplayedColumns;"></tr>
        </table>
      </div>
      <!-- ==================== END UPDATED BULK UPLOAD SECTION ==================== -->

      <!-- Hidden file input (CSV only) -->
      <input #fileInput type="file" accept=".csv" (change)="onFileSelected($event)" style="display: none;">

      <mat-card-actions class="mt-5">
        <div class="d-flex align-items-start align-items-sm-center">
          <div class="col-md-12 col-lg-12">
            <div class="nav-align-top">
              <ul class="nav nav-pills   nav-fill" role="tablist">

                <mat-list class="nav-item">
                  <button mat-button color="primary" type="button" class="nav-link active" role="tab"
                    data-bs-toggle="tab" data-bs-target="#navs-pills-justified-tablesuccess"
                    aria-controls="navs-pills-justified-tablesuccess" aria-selected="true">
                    Open
                  </button>
                </mat-list>

                <mat-list class="nav-item">
                  <button mat-button color="primary" type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                    data-bs-target="#navs-pills-justified-tablefail" aria-controls="navs-pills-justified-tablefail"
                    aria-selected="false">
                    Success
                  </button>
                </mat-list>

                <mat-list class="nav-item">
                  <button mat-button color="primary" type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                    data-bs-target="#navs-pills-justified-tableexpire" aria-controls="navs-pills-justified-tableexpire"
                    aria-selected="false">
                    Failed
                  </button>
                </mat-list>

                <mat-list class="nav-item">
                  <button mat-button color="primary" type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                    data-bs-target="#navs-pills-justified-tablenotopen"
                    aria-controls="navs-pills-justified-tablenotopen" aria-selected="false">
                    Expired
                  </button>
                </mat-list>
              </ul>
            </div>
          </div>
        </div>
      </mat-card-actions>
      <hr class="my-0  mb-3" />

      <mat-card-actions>
        <div class="text-align mt-3">
          <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
          </mat-form-field>
        </div>
      </mat-card-actions>

      <mat-card-content>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="navs-pills-justified-tablesuccess" role="tabpanel">
            <div class="card">
              <table mat-table [dataSource]="openDataSource" class="mat-elevation-z8" matSort
                (matSortChange)="announceSortChange($event)">

                <ng-container matColumnDef="srNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="0">S.No</th>
                  <td mat-cell *matCellDef="let item; let j = index">
                    {{ (j+1) + (open.pageIndex * open.pageSize) }}</td>
                  <!-- <td mat-cell *matCellDef="let element"> {{element.paymentRequestId}} </td> -->
                </ng-container>

                <ng-container matColumnDef="trackingno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="1">Tracking
                    Number</th>
                  <td mat-cell *matCellDef="let element">
                    <a [routerLink]="['/paymentLinkInfo',element.paymentRequestId]"
                      style="text-decoration: none;">{{element.custTrackingNo}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="paymentlink">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="2">Payment Link
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a [href]="element.queryString" style="text-decoration: none;" target="_blank">Link</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="vendorName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="3">Vendor Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                </ng-container>

                <ng-container matColumnDef="borrowerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="4">Borrower Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.payeeNameFirst}} </td>
                </ng-container>

                <ng-container matColumnDef="expire">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="5">Expire Date
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.expiresDT | date:'MM-dd-yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="cancel">
                  <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6"> Cancel</th>
                  <td mat-cell *matCellDef="let element">
                    <button type="button" class="btn btn-primary mb-3 mt-3"
                      (click)="cancelPayment(element.custTrackingNo,element.requestGUID)">Cancel</button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsOpen"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOpen;"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="7">No data matching the filter </td>
                </tr>
              </table>
              <div class="text-align mt-3">
                <mat-paginator #open [length]="this.openDataSource" [pageSize]="5" [pageSize]="5"
                  [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="navs-pills-justified-tablefail" role="tabpanel">
            <div class="card">
              <table mat-table [dataSource]="successDataSource" class="mat-elevation-z8" matSort
                (matSortChange)="announceSortChange($event)">
                <ng-container matColumnDef="srNo">
                  <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No</th>
                  <td mat-cell *matCellDef="let item; let j = index">
                    {{ (j+1) + (success.pageIndex * success.pageSize) }}</td>
                  <!-- <td mat-cell *matCellDef="let element"> {{element.paymentRequestId}} </td> -->
                </ng-container>

                <ng-container matColumnDef="trackingno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="1"> Tracking
                    Number</th>
                  <td mat-cell *matCellDef="let element" style="width: 350px;">
                    <a [routerLink]="['/paymentLinkInfo',element.paymentRequestId]"
                      style="text-decoration: none;">{{element.custTrackingNo}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="paymentlink">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="2">Payment Link
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a [href]="element.queryString" style="text-decoration: none;" target="_blank">Link</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="vendorName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="3">Vendor Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                </ng-container>

                <ng-container matColumnDef="borrowerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="4">Borrower Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.payeeNameFirst}} </td>
                </ng-container>

                <ng-container matColumnDef="expire">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="5">Expire Date
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.expiresDT | date:'MM-dd-yyyy'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="6">No data matching the filter </td>
                </tr>
              </table>
              <div class="text-align mt-3">
                <mat-paginator #success [length]="this.successDataSource" [pageSize]="5" [pageSize]="5"
                  [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="navs-pills-justified-tableexpire" role="tabpanel">
            <div class="card">
              <table mat-table [dataSource]="failedDataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8">

                <ng-container matColumnDef="srNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="0">S.No</th>
                  <td mat-cell *matCellDef="let item; let j = index">
                    {{ (j+1) + (fail.pageIndex * fail.pageSize) }}</td>
                  <!-- <td mat-cell *matCellDef="let element"> {{element.paymentRequestId}} </td> -->
                </ng-container>

                <ng-container matColumnDef="trackingno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="1"> Tracking
                    Number</th>
                  <td mat-cell *matCellDef="let element" style="width: 350px;">
                    <a [routerLink]="['/paymentLinkInfo',element.paymentRequestId]"
                      style="text-decoration: none;">{{element.custTrackingNo}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="paymentlink">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="2">Payment Link
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a [href]="element.queryString" style="text-decoration: none;" target="_blank">Link</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="vendorName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="3">Vendor Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                </ng-container>

                <ng-container matColumnDef="borrowerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="4">Borrower Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.payeeNameFirst}} </td>
                </ng-container>

                <ng-container matColumnDef="expire">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="5">Expire Date
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.expiresDT | date:'MM-dd-yyyy'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="6">No data matching the filter </td>
                </tr>
              </table>
              <div class="text-align mt-3">
                <mat-paginator #fail [length]="this.failedDataSource" [pageSize]="5" [pageSize]="5"
                  [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="navs-pills-justified-tablenotopen" role="tabpanel">
            <div class="card">
              <table mat-table [dataSource]="expiredDataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8">

                <ng-container matColumnDef="srNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="0">S.No</th>
                  <td mat-cell *matCellDef="let item; let j = index">
                    {{ (j+1) + (expired.pageIndex * expired.pageSize) }}</td>
                  <!-- <td mat-cell *matCellDef="let element"> {{element.paymentRequestId}} </td> -->
                </ng-container>

                <ng-container matColumnDef="trackingno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="1">Tracking
                    Number</th>
                  <td mat-cell *matCellDef="let element" style="width: 350px;">
                    <a [routerLink]="['/paymentLinkInfo',element.paymentRequestId]"
                      style="text-decoration: none;">{{element.custTrackingNo}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="paymentlink">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="2">Payment Link
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a [href]="element.queryString" style="text-decoration: none;" target="_blank">Link</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="vendorName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="3">Vendor Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                </ng-container>

                <ng-container matColumnDef="borrowerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="4">Borrower Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.payeeNameFirst}} </td>
                </ng-container>

                <ng-container matColumnDef="expire">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true" [index]="5">Expire Date
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.expiresDT | date:'MM-dd-yyyy'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="6">No data matching the filter </td>
                </tr>
              </table>
              <div class="text-align mt-3">
                <mat-paginator #expired [length]="this.expiredDataSource" [pageSize]="5" [pageSize]="5"
                  [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div id="loadingspinner" *ngIf="isLoading">
  <div class="spinner">
      <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
  </div>
</div>